import { Base64 } from 'js-base64';
import React, { useState, useEffect } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom';
import logo from '../../../../assets/images/logo/Haylo-for-white-background.png'
import logoThree from '../../../../assets/images/logo/Haylo-logo-white.png'
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import { baseURLPublic, URL_S3 } from '../../../../config/BaseUrl';
import '../style/microsite-one.css'
import '../style/style.css'
import { FiPlayCircle } from 'react-icons/fi'


function MicrositeOne() {

  window.addEventListener('beforeunload', function (e) {
    e.preventDefault()

    localStorage.removeItem('galleryPasswordCheck')
  })

  const { id } = useParams()
  const history = useHistory();
  const eventId = Base64.atob(id);
  // const socialGalleryTemplate = history.location.state.socialGallery

  const [loading, setLoading] = useState(false);
  const [galleryItems, setGalleryItems] = useState([]);
  const [galleryData, setGallery] = useState(null)
  const [socialGalleryTemplate, setSocialGalleryTemplate] = useState(null)
  const fetchMicroSiteGalleryItems = async () => {
    try {
      setLoading(true)
      await baseURLPublic.get(`social-gallery-item/${eventId}`).then((res) => {
        let gallery = null
        if (res) {
          gallery = res.data.gallery
          setGallery(gallery)
          setGalleryItems(res.data.gallery_items)
        }
        let eventIds = eventId
        if (gallery) {
          if (gallery.gallery_password) {
            if (!localStorage.getItem('galleryPasswordCheck')) {
              history.replace(`/social/gallery/password/${id}`)
            }
          }

          if (gallery.tag_script) {
            stringToHTML(gallery.tag_script)
          }

        }
        baseURLPublic.get(`social-gallery-share-item/${eventIds}`)
          .then((res) => {
            let shareItem = res.data && res.data;
            let templateName = shareItem.share_gallery && shareItem.share_gallery.micro_site_gallery.template_name;
            if (templateName !== null) {
              setSocialGalleryTemplate(templateName)
            } else {
              setSocialGalleryTemplate("one")
            }
            setLoading(false)
          })

      })
    } catch (error) {

    }
  }

  useEffect(() => {
    fetchMicroSiteGalleryItems()
  }, [])

  console.log(galleryItems);

  const stringToHTML = (str) => {
    const frag = document.createRange().createContextualFragment(str)

    document.head.appendChild(frag);
    return true;
  };

  const imageClassDec = (indexImage, type) => {
    if (type !== "photo") {
      return 'big'
    }
    else if (indexImage === 0) {
      return 'big'
    }
    else if (indexImage % 4 === 0) {
      return 'vertically-big'
    }
    else if (indexImage % 4 === 2) {
      return 'horizontally-big'
    }
    else {
      return 'small'
    }
  }



  return (<>

    {loading ?
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100vh' }}>
        <LoadingSpinner />
        <h6 className="mt-2">Please wait...</h6>
      </div>
      : <>


        {socialGalleryTemplate === 'one' &&

          <div className="microsite-template">
            <div className="microsite-template-header-one">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="py-4 text-center template-one-header-content">
                      <img src={logo} className="img-fluid" alt="logo" style={{ width: "250px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="py-5 microsite-body">
              <div className="container">
                <div className="row justify-content-center">
                  <div className='col-12'>
                    <div className='gallery-images'>
                      {!loading ? galleryItems && galleryItems.map((res, index) => (
                        <div className={imageClassDec(index, res.media_type)} key={res.id}>
                          <Link to={`/social/gallery/view/${Base64.btoa(res.id)}`}>
                          {
                              res.media_type === 'photo' ? <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" /> :
                                res.media_type === 'video' ?
                                  (<span className="video">
                                    <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                    <span className="video-icon"><FiPlayCircle /></span>
                                  </span>)
                                  :
                                  res.media_type === 'gif' ?
                                    (<span className="video">
                                      <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                      <span className="video-icon"><FiPlayCircle /></span>
                                    </span>) :
                                    res.media_type === 'burst_gif' ?
                                      (<span className="video">
                                        <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                        <span className="video-icon"><FiPlayCircle /></span>
                                      </span>) :
                                      res.media_type === 'boomerang' ? (<span className="video">
                                        <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                        <span className="video-icon"><FiPlayCircle /></span>
                                      </span>) : ''
                            }
                          </Link>
                        </div>
                      )) : (
                        <LoadingSpinner />
                      )}
                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div className="footer-microsite-one">
              <div className="container">
                <div className="row justify-content-center">
                  <p className="text-center footer-name mb-0 py-4">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
                </div>
              </div>
            </div>

          </div>

        }

        {socialGalleryTemplate === 'two' &&


          <div className="customer-microsite-two">
            <div className="header default-header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="header-image text-center py-4">
                      <img src={logo} className="img-fluid" alt="logo" style={{ width: "250px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-body mt-5 microsite-item-body py-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className='col-12'>
                    <div className='gallery-images'>
                      {!loading ? galleryItems && galleryItems.map((res, index) => (
                        <div className={imageClassDec(index, res.media_type)} key={res.id}>
                          <Link to={`/social/gallery/view/${Base64.btoa(res.id)}`}>
                          {
                              res.media_type === 'photo' ? <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" /> :
                                res.media_type === 'video' ?
                                  (<span className="video">
                                    <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                    <span className="video-icon"><FiPlayCircle /></span>
                                  </span>)
                                  :
                                  res.media_type === 'gif' ?
                                    (<span className="video">
                                      <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                      <span className="video-icon"><FiPlayCircle /></span>
                                    </span>) :
                                    res.media_type === 'burst_gif' ?
                                      (<span className="video">
                                        <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                        <span className="video-icon"><FiPlayCircle /></span>
                                      </span>) :
                                      res.media_type === 'boomerang' ? (<span className="video">
                                        <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                        <span className="video-icon"><FiPlayCircle /></span>
                                      </span>) : ''
                            }
                          </Link>
                        </div>
                      )) : (
                        <LoadingSpinner />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-microsite-one">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <p className="text-center footer-name mb-0 py-5">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
                  </div>
                </div>
              </div>
            </div>

          </div>


        }

        {socialGalleryTemplate === 'three' &&

          <div className="Customer-microsite-default">

            <div className="header default-header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="header-image text-center py-4">
                      <img src={logoThree} className="img-fluid" alt="logo" style={{ width: "250px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-body mt-5">
              <div className="container">
                <div className="row justify-content-center">
                  <div className='col-12'>
                    <div className='gallery-images'>
                      {!loading ? galleryItems && galleryItems.map((res, index) => (
                        <div className={imageClassDec(index, res.media_type)} key={res.id}>
                          <Link to={`/social/gallery/view/${Base64.btoa(res.id)}`}>
                            {
                              res.media_type === 'photo' ? <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" /> :
                                res.media_type === 'video' ?
                                  (<span className="video">
                                    <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                    <span className="video-icon"><FiPlayCircle /></span>
                                  </span>)
                                  :
                                  res.media_type === 'gif' ?
                                    (<span className="video">
                                      <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                      <span className="video-icon"><FiPlayCircle /></span>
                                    </span>) :
                                    res.media_type === 'burst_gif' ?
                                      (<span className="video">
                                        <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                        <span className="video-icon"><FiPlayCircle /></span>
                                      </span>) :
                                      res.media_type === 'boomerang' ? (<span className="video">
                                        <img src={URL_S3 + 'event_gallery/photo/' + res.event_photo} alt="random-item" className="img-fluid" />
                                        <span className="video-icon"><FiPlayCircle /></span>
                                      </span>) : ''
                            }
                          </Link>
                        </div>
                      )) : (
                        <LoadingSpinner />
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="micro-site-footer">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <p className="text-center footer-name mb-0 py-5">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
                  </div>
                </div>
              </div>
            </div>

          </div>

        }


      </>}
  </>)
}

export default MicrositeOne
